import { downloadFromBlobUrl } from "../../../../../common/utils/download_utils";
import { IDownloadFuncionarioAssinaturaUseCase } from "../../../presentation/useCases/read/download_funcionario_assinatura_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DownloadFuncionarioAssinaturaUseCase
 */

export class DownloadFuncionarioAssinaturaUseCase implements IDownloadFuncionarioAssinaturaUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async downloadFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
    arquivoNome: string,
  ): Promise<void> {
    const result = await this.repository.downloadFuncionarioAssinatura(idFuncionarioAssinatura);
    await downloadFromBlobUrl(result, arquivoNome);
  }
}
